import { AccountManager } from 'containers/AccountManager'

export default AccountManager
